import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getTrackIcon',
  standalone: true
})
export class GetTrackIconPipe implements PipeTransform {


  // TBred: 1 - suit light & dark
  // Greyhound: 2 - dog blue
  // Harness: 4 - horse blue

  transform(trackType: any, suit: string, greyhound: string, harness: string): string {
    let icon = '';

    switch (trackType) {
      case 1:
      case 3:
        icon = suit;
        break;
      case 2:
        icon = greyhound;
        break;
      case 4:
        icon = harness;
        break;
      default:
        break;
    }

    return icon;
  }

}
